import React, { useState } from "react";
import { sbFetch } from "../utils/supabaseClient";
import { useToast } from "./Toast";
import "../styles/CreateTab.css";

const EventEditModal = ({ event, onSave, onCancel }) => {
  const { success, error } = useToast();
  const [title, setTitle] = useState(event.title || "");
  const [description, setDescription] = useState(event.description || "");
  const [eventDate, setEventDate] = useState(event.date_time ? event.date_time.split('T')[0] : "");
  const [eventTime, setEventTime] = useState(event.date_time ? event.date_time.split('T')[1].slice(0, 5) : "");
  const [location, setLocation] = useState(event.location || "");
  const [imageUrl, setImageUrl] = useState(event.image_url || "");
  const [speakerName, setSpeakerName] = useState(event.speaker_name || "");
  const [speakerTitle, setSpeakerTitle] = useState(event.speaker_title || "");
  const [eventType, setEventType] = useState(event.event_type || "lunch-and-learn");
  const [capacity, setCapacity] = useState(event.capacity || "");
  const [registrationUrl, setRegistrationUrl] = useState(event.registration_url || "");
  const [draft, setDraft] = useState(event.draft || false);
  const [saving, setSaving] = useState(false);

  const eventTypes = [
    { value: "lunch-and-learn", label: "Lunch & Learn" },
    { value: "workshop", label: "Workshop" },
    { value: "webinar", label: "Webinar" },
    { value: "conference", label: "Conference" },
    { value: "round-table", label: "Round Table" },
    { value: "other", label: "Other" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim() || !eventDate.trim() || !eventTime.trim()) {
      error("Title, Date, and Time are required");
      return;
    }

    setSaving(true);
    try {
      const dateTimeString = `${eventDate}T${eventTime}`;
      const updated = {
        title: title.trim(),
        description: description.trim(),
        date_time: new Date(dateTimeString).toISOString(),
        location: location.trim(),
        image_url: imageUrl.trim(),
        speaker_name: speakerName.trim(),
        speaker_title: speakerTitle.trim(),
        event_type: eventType,
        capacity: capacity ? parseInt(capacity) : null,
        registration_url: registrationUrl.trim(),
        draft: draft,
      };

      await sbFetch("PATCH", `events?id=eq.${event.id}`, updated);
      success("Event updated successfully");
      onSave(updated);
    } catch (err) {
      console.error("Error updating event:", err);
      error("Failed to update event");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: "#050e1a",
          borderRadius: "8px",
          width: "90%",
          maxWidth: "700px",
          maxHeight: "90vh",
          overflowY: "auto",
          border: "1px solid rgba(59, 130, 246, 0.2)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px", borderBottom: "1px solid rgba(59, 130, 246, 0.2)" }}>
          <h2 style={{ margin: 0, color: "#5B9EF0" }}>Edit Event</h2>
          <button
            onClick={onCancel}
            style={{
              background: "transparent",
              border: "none",
              color: "#7A9CC4",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: "20px" }}>
          <div className="form-group">
            <label>Event Title *</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g., AI Leadership in 2025"
              disabled={saving}
            />
          </div>

          <div className="form-group">
            <label>Event Date *</label>
            <input
              type="date"
              value={eventDate}
              onChange={(e) => setEventDate(e.target.value)}
              disabled={saving}
              style={{ width: "100%" }}
            />
          </div>

          <div className="form-group">
            <label>Event Time *</label>
            <select
              value={eventTime}
              onChange={(e) => setEventTime(e.target.value)}
              disabled={saving}
              style={{ width: "100%" }}
            >
              <option value="">-- Select Time --</option>
              <option value="06:00">6:00 AM</option>
              <option value="07:00">7:00 AM</option>
              <option value="08:00">8:00 AM</option>
              <option value="09:00">9:00 AM</option>
              <option value="10:00">10:00 AM</option>
              <option value="11:00">11:00 AM</option>
              <option value="12:00">12:00 PM</option>
              <option value="13:00">1:00 PM</option>
              <option value="14:00">2:00 PM</option>
              <option value="15:00">3:00 PM</option>
              <option value="16:00">4:00 PM</option>
              <option value="17:00">5:00 PM</option>
              <option value="18:00">6:00 PM</option>
              <option value="19:00">7:00 PM</option>
              <option value="20:00">8:00 PM</option>
            </select>
          </div>

          <div className="form-group">
            <label>Event Type</label>
            <select
              value={eventType}
              onChange={(e) => setEventType(e.target.value)}
              disabled={saving}
              style={{ width: "100%" }}
            >
              {eventTypes.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Location</label>
            <input
              type="text"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              placeholder="e.g., Conference Room B or Zoom"
              disabled={saving}
            />
          </div>

          <div className="form-group">
            <label>Event Image URL</label>
            <input
              type="url"
              value={imageUrl}
              onChange={(e) => setImageUrl(e.target.value)}
              placeholder="https://example.com/image.jpg"
              disabled={saving}
            />
            <small style={{ color: "#7A9CC4", marginTop: "4px", display: "block" }}>
              Recommended: 800px × 400px
            </small>
            {imageUrl && (
              <img
                src={imageUrl}
                alt="Event preview"
                style={{
                  width: "100%",
                  maxHeight: "150px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  border: "1px solid rgba(59, 130, 246, 0.15)",
                  marginTop: "8px",
                }}
              />
            )}
          </div>

          <div className="form-group">
            <label>Speaker Name</label>
            <input
              type="text"
              value={speakerName}
              onChange={(e) => setSpeakerName(e.target.value)}
              placeholder="e.g., Jane Smith"
              disabled={saving}
            />
          </div>

          <div className="form-group">
            <label>Speaker Title/Role</label>
            <input
              type="text"
              value={speakerTitle}
              onChange={(e) => setSpeakerTitle(e.target.value)}
              placeholder="e.g., Chief AI Officer"
              disabled={saving}
            />
          </div>

          <h3 style={{ margin: "20px 0 12px 0", color: "#5B9EF0", fontSize: "16px", fontWeight: "600" }}>About this Event</h3>

          <div className="form-group">
            <label>Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Event details, agenda, and description..."
              disabled={saving}
              style={{ minHeight: "100px" }}
            />
          </div>

          <div className="form-group">
            <label>Capacity (Optional)</label>
            <input
              type="number"
              value={capacity}
              onChange={(e) => setCapacity(e.target.value)}
              placeholder="Max attendees"
              disabled={saving}
              min="0"
            />
          </div>

          <div className="form-group">
            <label>Registration URL (Optional)</label>
            <input
              type="url"
              value={registrationUrl}
              onChange={(e) => setRegistrationUrl(e.target.value)}
              placeholder="https://eventregistration.com/..."
              disabled={saving}
            />
          </div>

          <div className="form-group" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="checkbox"
              id="draft"
              checked={draft}
              onChange={(e) => setDraft(e.target.checked)}
              disabled={saving}
              style={{ cursor: "pointer" }}
            />
            <label htmlFor="draft" style={{ margin: 0, cursor: "pointer" }}>
              Save as Draft
            </label>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? "Updating..." : "💾 Update Event"}
            </button>
            <button type="button" onClick={onCancel} className="btn-secondary" disabled={saving}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EventEditModal;
